/** 허브 월별 통계 엔티티 */
export default class StatsHubMonthly {
    /** 아이디 */
    id = 0;
    /** 총판 이름 */
    distName = '';
    /** 허브 이름 */
    hubName = '';
    date = '';
    goodsSalesAll = 0;
    goodsUnitPriceAll = 0;
    doneCountPerCategoryAll = 0;
    deliveryFeeAll = 0;
    deliveryFeeAvg = 0;
    completedCountAll = 0;
    completedCountCash = 0;
    completedCountCard = 0;
    completedCountMileage = 0;
    completedCountCredit = 0;
    completedRatioCash = 0;
    completedRatioCard = 0;
    completedRatioMileage = 0;
    completedRatioCredit = 0;
    cancelCount = 0;
    inquiryCount = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
